/**
 * Serviço para integração de dados auxiliares dos templates
 * 
 * Fornece dados de fornecedores e cargos utilizados nos formulários.
 * 
 * TODO: Integrar com sistema Protheus da TOTVS para buscar fornecedores adicionais
 */

export interface Fornecedor {
  id: string
  nome: string
  razao_social: string
  cnpj: string
}

export interface Cargo {
  id: string
  nome: string
}

/**
 * Lista fixa de fornecedores principais
 */
const FORNECEDORES_FIXOS: Fornecedor[] = [
  {
    id: '1',
    nome: 'SESI',
    razao_social: 'Serviço Social da Indústria - SESI',
    cnpj: '03804862000165',
  },
  {
    id: '2',
    nome: 'SENAI',
    razao_social: 'Serviço Nacional de Aprendizagem Industrial - SENAI',
    cnpj: '03792339000166',
  },
  {
    id: '3',
    nome: 'IEL',
    razao_social: 'Instituto Euvaldo Lodi - IEL',
    cnpj: '02373341000138',
  },
  {
    id: '4',
    nome: 'FIEAC',
    razao_social: 'Federação das Indústrias do Estado do Acre - FIEAC',
    cnpj: '14366215000135',
  },
]

/**
 * Lista fixa de cargos disponíveis
 */
const CARGOS_FIXOS: Cargo[] = [
  { id: '', nome: '1º Secretário FIEAC' },
  { id: '', nome: '1º Tesoureiro FIEAC' },
  { id: '', nome: '1º Vice-Presidente FIEAC' },
  { id: '', nome: '2º Secretário FIEAC' },
  { id: '', nome: '2º Tesoureiro FIEAC' },
  { id: '', nome: 'Agente Operacional' },
  { id: '', nome: 'Analista Educacional' },
  { id: '', nome: 'Analista de Tecnologia da Informação' },
  { id: '', nome: 'Analista de Promoção a Saúde' },
  { id: '', nome: 'Analista de Suporte à Gestão' },
  { id: '', nome: 'Analista de integridade de Dados' },
  { id: '', nome: 'Arquiteto e Urbanista' },
  { id: '', nome: 'Assessor de Relações Institucionais' },
  { id: '', nome: 'Assistente de Diretoria' },
  { id: '', nome: 'Assistente de Infraestrutura' },
  { id: '', nome: 'Assistente de Suporte a Gestão' },
  { id: '', nome: 'Auditor Compliance' },
  { id: '', nome: 'Bibliotecario' },
  { id: '', nome: 'Conselho Fiscal Suplente FIEAC' },
  { id: '', nome: 'Conselho Fiscal Titular FIEAC' },
  { id: '', nome: 'Consultor de Tecnologia e Inovação' },
  { id: '', nome: 'Coordenador Técnico' },
  { id: '', nome: 'Coordenador de Área' },
  { id: '', nome: 'Coordenador de Gabinete' },
  { id: '', nome: 'Coordenador de Pedagógico' },
  { id: '', nome: 'Diretor regional' },
  { id: '', nome: 'Enfermeiro do Trabalho' },
  { id: '', nome: 'Engenheiro Civil' },
  { id: '', nome: 'Engenheiro Eletricista' },
  { id: '', nome: 'Engenheiro da Segurança do Trabalho' },
  { id: '', nome: 'Ergonomista' },
  { id: '', nome: 'Estagiário(a)' },
  { id: '', nome: 'Gerente de Área' },
  { id: '', nome: 'Gerente de Saúde e Segurança' },
  { id: '', nome: 'Gerente de Unidade' },
  { id: '', nome: 'Instrutor Médio/Técnico' },
  { id: '', nome: 'Instrutor Superior' },
  { id: '', nome: 'Médico do Trabalho' },
  { id: '', nome: 'Monitor Educacional' },
  { id: '', nome: 'Orientador Educacional' },
  { id: '', nome: 'Ouvidor' },
  { id: '', nome: 'Presidente FIEAC' },
  { id: '', nome: 'Prestador(a)' },
  { id: '', nome: 'Professor' },
  { id: '', nome: 'Professor da Educação de Jovens e Adultos do Ensino Médio' },
  { id: '', nome: 'Professor de Disciplinas Pedagógicas no ensino medio' },
  { id: '', nome: 'Professor de Educação Especial' },
  { id: '', nome: 'Professor de Nível Superior do Ensino Fundamental(Primeira à Quarta Série)' },
  { id: '', nome: 'Professor de Nível Superior do Ensino Fundamental(Quinta à Oitava Série)' },
  { id: '', nome: 'Professor de Nível Superior do Ensino Infantil(Quatro a Seis Anos)' },
  { id: '', nome: 'Psicólogo Escolar' },
  { id: '', nome: 'Secretária Escolar' },
  { id: '', nome: 'Suplente FIEAC' },
  { id: '', nome: 'Técnico de Segurança do Trabalho' },
  { id: '', nome: 'Técnico de Serviço de Tecnologia e Inovação' },
  { id: '', nome: 'Técnico de Suporte a Gestão' },
  { id: '', nome: 'Técnico em tecnologia da Informação' },
  { id: '', nome: 'Vice-Presidente FIEAC' },
];

class IntegracaoDadosService {
  /**
   * Busca todos os fornecedores
   * 
   * Atualmente retorna lista fixa de 4 fornecedores.
   * TODO: Integrar com Protheus para buscar fornecedores adicionais
   */
  async getFornecedores(): Promise<Fornecedor[]> {
    // Simula chamada assíncrona
    await new Promise(resolve => setTimeout(resolve, 100))
    
    // TODO: Adicionar integração com Protheus
    // const fornecedoresProtheus = await buscarFornecedoresProtheus()
    // return [...FORNECEDORES_FIXOS, ...fornecedoresProtheus]
    
    return [...FORNECEDORES_FIXOS]
  }

  /**
   * Busca todos os cargos disponíveis
   */
  async getCargos(): Promise<Cargo[]> {
    // Simula chamada assíncrona
    await new Promise(resolve => setTimeout(resolve, 100))
    
    return [...CARGOS_FIXOS].sort((a, b) => a.nome.localeCompare(b.nome))
  }

  /**
   * Adiciona novo fornecedor
   * 
   * TODO: Implementar persistência (Protheus ou outra fonte)
   */
  async adicionarFornecedor(fornecedor: Omit<Fornecedor, 'id'>): Promise<Fornecedor> {
    console.warn('Adicionar fornecedor ainda não implementado. TODO: Integrar com Protheus')
    
    // Simula sucesso
    const novoFornecedor: Fornecedor = {
      id: String(Date.now()),
      ...fornecedor,
    }
    
    await new Promise(resolve => setTimeout(resolve, 500))
    
    return novoFornecedor
  }
}

export const integracaoDadosService = new IntegracaoDadosService()
